import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_TAGX: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_TAGX_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_TAGX_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.TAGX_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.TAGX_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.TAGX_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.TAGX_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.TAGX_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
